import { combineReducers } from 'redux'
import tabs from './tabs'
import buttons from './buttons'
import collapsed from './collapsed'
import globalReport from './globalReport'
import target from './target'
const rootReducer = combineReducers({
    tabs,
    buttons,
    collapsed,
    globalReport,
    target,
})
export default rootReducer